import React, { useState, useEffect, useRef, useContext } from "react";
import {
  ContentWrapper,
  SnackbarContent,
  PageTitle,
  PageSubTitle,
} from "../../styled-components/shared";
import Snackbar from "@material-ui/core/Snackbar";
import TextField from "@material-ui/core/TextField";
import MUButton from "@material-ui/core/Button";
import Chip from "@material-ui/core/Chip";
import styled from "styled-components";
import firebaseUtil from "../../data/FirebaseUtil";
import pkceUtil from "../../data/pkceUtil";
import { SSOSettingsContext } from "../../authentication/SSOSettings";
import { DataContext } from "../../data/DataContext";
import CircularProgress from "@material-ui/core/CircularProgress";
import AlertModal from "../../components/modals/AlertModal";
import SSOConfigTestModal from "../../components/modals/SSOConfigTestModal";
import SSODeactivatetModal from "../../components/modals/SSODeactivatetModal";
import config from "../../data/application.properties";
import { SSO_CONSTANTS, SSO_STATUS_CONSTANTS, sc } from "../../data/constants";
import { useTranslation } from "react-i18next";
import Switch from "@material-ui/core/Switch";
import BottomNavLinks from "../../components/BottomNavLinks";
import { AuthContext } from "../../authentication/Auth";
import Grid from "@material-ui/core/Grid";
import FormControl from "@material-ui/core/FormControl";
import DropdownCustom from "../../components/DropdownCustom";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import AzureSSOConfig from "./azureSSO";
import PingFred from "./pingfredSSO";
import ChipInput from 'material-ui-chip-input';

const StyledContentWrapper = styled(ContentWrapper)`
  padding: 20px;
  @media screen and (max-width: 750px) {
    overflow-x: hidden;
  }
`;

const SubHeader = styled.h2`
  font-size: 16px;
  color: #4c4c4c;
  margin: 0;
  line-height: 24px;
  font-weight: 400;
  font-family:Roboto;
`;

  const StyledChipInput = styled(ChipInput)`
  border-color:1px #2684ff !important;
  background-color: #FAFBFC !important;
   
  `;

const StyledTextField = styled(TextField)`
  width: 736px
  height: 44px
  border-radius: 4px
  border: 1px
  .MuiOutlinedInput-root {
    font-size: 14px !important; 
  }

  input {
    font-size: 14px !important;
    background-color: #FAFBFC !important;
    padding: 15px !important;

    &:focus {
      border-color:1px #2684ff !important;
      background-color: #FAFBFC !important;
    }
  }
`;

const SubHeaderWithAsterisk = styled.h2`
  font-size: 16px;
  color: #4c4c4c;
  margin: 0;
  line-height: 19px;
  font-weight: 600;
  &:after {
    content: " *";
    font-size: 18px;
    color: #ff0000;
    font-weight: 800;
  }
`;

const CustomAlertText = styled.p`
  font-size: 16px;
  color: #ffffff;
  margin: 0;
  &:before {
    content: "*";
    color: #ff0000;
    font-size: 16px;
    font-weight: 800;
  }
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  max-width: 736px;
  margin-bottom: 10px;
  & > *:first-child {
    flex: 1;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  max-width: 736px;
  align-items: flex-end;
  justify-content: flex-end;
`;

const CheckboxHolder = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 228px;
`;

const MButton = styled(MUButton)`
  background-color: rgb(0, 122, 186) !important;
  color: rgb(255, 255, 255) !important;
  border-radius: 0 !important;
`;

const Image = styled.img`
  width: 18px;
  height: 18px;
  margin-right: 5px;
  margin-left: 5px;
  margin-bottom: 15px;
`;

const StyledChip = styled(Chip)`
  margin: 0px 4px 9px 4px;
  max-width: 95%;
`;

export default function SettingsPage() {
  let { globalAppSettings } = useContext(DataContext);
  const { SSOSettings, setSSOSettings, refreshSSOSettings,setAuthSSOProvider } =
    useContext(SSOSettingsContext);
  const [ssoSetting, setSSOSetting] = useState({ ssoLogin: false });
  const [saveData, setSaveData] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading2, setIsLoading2] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [message, setMessage] = useState("");
  const [ssoConfigEnable, setSSOConfigEnable] = useState({ isChecked: false });
  // ssoTestStatus 0 - Inprogress, 1 - Success, 2 - Failed
  const [ssoTestStatus, setSsoTestStatus] = useState(
    SSO_STATUS_CONSTANTS.SSOTESTSTATUS.PROGRESS
  );
  const [ssoActive, setSSOactive] = useState(false);
  /**
   * ssoTestStepStatus 0
   *  Authorization Endpoint Validation Inprogress
   * ssoTestStepStatus 1
   *  Authorization Endpoint Validation Success
   *  Token Endpoint Validation Inprogress
   * ssoTestStepStatus 2
   *  Authorization Endpoint Validation Success
   *  Token Endpoint Validation Success
   *  Revoke Token Endpoint Validation Inprogress
   *  Logout Endpoint Validation Inprogress
   * ssoTestStepStatus 3
   *  Authorization Endpoint Validation Success
   *  Token Endpoint Validation Success
   *  Revoke Token Endpoint Validation Success
   *  Logout Endpoint Validation Success
   */
  const [ssoTestStepStatus, setSsoTestStepStatus] = useState(
    SSO_STATUS_CONSTANTS.SSOTESTSTEPSTATUS.AUTHORIZATION
  );
  const [dataBaseSSO, setDataBaseSSO] = useState(false);
  const serverResponse = useRef("");
  const ssoConfigTestModalRef = useRef();
  const ssoDeactivateModalRef = useRef();
  const alertModalRef = useRef();
  const { t } = useTranslation();
  const { currentUser } = useContext(AuthContext);
  const [ssoProvider, setSsoProvider] = React.useState({
    label: "Ping indenity",
    value: 1,
  });
  const [ssoProviders, setSsoProviders] = React.useState([
    { label: t('chooseOne'), value: 0, isdisabled: true },
    { label: t('pingIdentity'), value: 1 },
    { label: t('microsoft'), value: 2 },
  ]);

  useEffect(() => {
    refreshSSOSettings();
    //setTimeout(() => { setIsLoading2(false) }, 1000)
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (SSOSettings) {
      setDataBaseSSO(SSOSettings.ssoLogin);
      if (SSOSettings.ssoProvider > 0) {
        setSSOSetting({
          ssoLogin: true,
        });
      }

      console.log("setSSOSetting==========>", SSOSettings);
      console.log("setSSOSetting==========>", SSOSettings.ssoProvider);
      setSsoProvider(ssoProviders[SSOSettings.ssoProvider]);
    }
    console.log("SSOSettings", SSOSettings);
    if (
      SSOSettings.webClientId == null ||
      (SSOSettings.webClientId === "" &&
        SSOSettings.androidClientId === null) ||
      (SSOSettings.androidClientId === "" &&
        SSOSettings.enterpriseClientId === null) ||
      SSOSettings.enterpriseClientId === ""
    ) {
      setIsLoading2(true);
    } else {
      setIsLoading2(false);
    }
  }, [SSOSettings]);

  async function handleSave() {
    if (navigator.onLine) {
      let settingsData = {
        ...saveData,
        ssoLogin: true,
        checkin: globalAppSettings.checkin,
        ssoProvider: ssoProvider.value,
      };

      if (ssoTestStatus === 1) {
        ssoConfigTestModalRef.current.close();
        setIsLoading(true);
        console.log("settingsData============>", settingsData);
        let response = await firebaseUtil.saveSSOSettings(settingsData);
        setSSOSettings(settingsData);
        setDataBaseSSO(true);
        setIsLoading(false);
        serverResponse.current = response;
        setSnackbarOpen(true);
      }
    } else {
      setErrorMessage(t("messages.error.err44"));
      ssoConfigTestModalRef.current.close();
      alertModalRef.current.toggleDialog();
    }
  }

  /**
   * SSO Configuration Test start here
   */
  async function handleSSOTestConfig(ssoSettingWithoutTrim) {
    console.log(
      "ssoSettingWithoutTrim====================>",
      ssoSettingWithoutTrim
    );
    if (navigator.onLine) {
      //if SSO role mapping disabled reset following parameter values
      if (!ssoSettingWithoutTrim.ssoParameterMappingEnable) {
        ssoSettingWithoutTrim.siteNameParam = "";
        ssoSettingWithoutTrim.adminRoleParam = "";
        ssoSettingWithoutTrim.managerRoleParam = "";
        ssoSettingWithoutTrim.adminRoles = [];
        ssoSettingWithoutTrim.managerRoles = [];
      }

      let adminRoles = ssoSettingWithoutTrim.adminRoles.map((val) =>
        val.trim()
      );
      let managerRoles = ssoSettingWithoutTrim.managerRoles.map((val) =>
        val.trim()
      );

      console.log("Roles MM==== ", adminRoles, managerRoles);
      let roleResponse = await firebaseUtil.mapdtrkToSSORoles({
        dtrk2SSORoles: {
          Admin: adminRoles,
          Manager: managerRoles,
        },
      });

      console.log("roleResponse MM==== ", roleResponse, roleResponse);

      setDataBaseSSO(false);
      console.log(ssoSettingWithoutTrim, "ssoSettingWithoutTrim");

      const ssoSetting = {
        androidClientId: ssoSettingWithoutTrim.androidClientId?.trim(),
        androidRedirectURI: ssoSettingWithoutTrim.androidRedirectURI?.trim(),
        authorizationScope: ssoSettingWithoutTrim.authorizationScope?.trim(),
        authorizationURL: ssoSettingWithoutTrim.authorizationURL?.trim(),
        enterpriseClientId: ssoSettingWithoutTrim.enterpriseClientId
          ? ssoSettingWithoutTrim.enterpriseClientId.trim()
          : "",
        enterpriseRedirectURI:
          ssoSettingWithoutTrim.enterpriseRedirectURI?.trim(),
        introspectionURL: ssoSettingWithoutTrim.introspectionURL?.trim(),
        logoutURL: ssoSettingWithoutTrim.logoutURL?.trim(),
        passcode: ssoSettingWithoutTrim.passcode
          ? ssoSettingWithoutTrim.passcode.trim()
          : "",
        revokeURL: ssoSettingWithoutTrim.revokeURL?.trim(),
        adminRoleParam: ssoSettingWithoutTrim.adminRoleParam?.trim(),
        managerRoleParam: ssoSettingWithoutTrim.managerRoleParam?.trim(),
        tokenURL: ssoSettingWithoutTrim.tokenURL?.trim(),
        userNameParam: ssoSettingWithoutTrim.userNameParam?.trim(),
        webClientId: ssoSettingWithoutTrim.webClientId?.trim(),
        webRedirectURI: ssoSettingWithoutTrim.webRedirectURI?.trim(),
        siteNameParam: ssoSettingWithoutTrim.siteNameParam?.trim(),
        admin: adminRoles,
        manager: managerRoles,
        ssoParameterMappingEnable:
          ssoSettingWithoutTrim.ssoParameterMappingEnable, // DLM-19585
        userInfoURL: ssoSettingWithoutTrim.userInfoURL?.trim(), //DLM-20088
        clientAuthType: ssoSettingWithoutTrim.clientAuthType, //DLM-20746
        enablePKCE: ssoSettingWithoutTrim.enablePKCE,
        ssoProvider: ssoProvider.value,
        clientSecret: ssoSettingWithoutTrim?.clientSecret?.trim(),
      };

      setSsoTestStatus(SSO_STATUS_CONSTANTS.SSOTESTSTATUS.PROGRESS);
      setSsoTestStepStatus(
        SSO_STATUS_CONSTANTS.SSOTESTSTEPSTATUS.AUTHORIZATION
      );
      setMessage("");
      //setMessage("Authorization URL Validation Inprogress");
      ssoConfigTestModalRef.current.toggleDialog();
      let ssoTestSetting = {
        ...ssoSetting,
        ssoLogin: false,
        isValidate: true,
        ssoProvider: ssoProvider.value,
      };

      if (ssoProvider.value === 2) {
        ssoTestSetting = {
          ...ssoTestSetting,
          clientSecret: ssoSettingWithoutTrim?.clientSecret?.trim(),
        };
      }

      setSaveData(ssoSetting);

      var enablePKCE = false;
      var ssoURL = "";
      if (typeof ssoSettingWithoutTrim.enablePKCE != "undefined") {
        console.log("PKCE was undefined");

        enablePKCE = ssoSettingWithoutTrim.enablePKCE;
      } else {
        if (
          typeof ssoSettingWithoutTrim.clientAuthType != "undefined" &&
          ssoSettingWithoutTrim.clientAuthType === 0
        ) {
          enablePKCE = true;
        }
      }
      console.log("enablePKCE: " + enablePKCE);
      if (enablePKCE) {
        const codeVerifierAndChallenge =
          await pkceUtil.codeVerifierAndChallenge();
        localStorage.setItem(
          "codeVerifier",
          codeVerifierAndChallenge.codeVerifier
        );
        await firebaseUtil.saveSSOSettings(ssoTestSetting);
        ssoURL = `${ssoSetting.authorizationURL}?response_type=code&client_id=${
          ssoSetting.webClientId
        }&redirect_uri=${ssoSetting.webRedirectURI}&scope=${encodeURI(
          ssoSetting.authorizationScope
        )}&code_challenge=${
          codeVerifierAndChallenge.challenge
        }&code_challenge_method=S256&prompt=login`;
      } else {
        await firebaseUtil.saveSSOSettings(ssoTestSetting);
        ssoURL = `${ssoSetting.authorizationURL}?response_type=code&client_id=${
          ssoSetting.webClientId
        }&redirect_uri=${ssoSetting.webRedirectURI}&scope=${encodeURI(
          ssoSetting.authorizationScope
        )}&prompt=login`;
      }
      if (ssoURL != "") {
        let response = await firebaseUtil.testSSOSettings({
          url: ssoURL,
        });
        if (response.status === 200) {
          localStorage.setItem("ssoTestStatus", "true");
          currentUser.getIdTokenResult().then((response) => {
            if (JSON.parse(localStorage.getItem("ssoLogin")) === true) {
              localStorage.setItem("loggedInUserEmail", response.claims.sub);
            } else {
              localStorage.setItem("loggedInUserEmail", response.claims.email);
            }
          });
          setSsoTestStepStatus(SSO_STATUS_CONSTANTS.SSOTESTSTEPSTATUS.TOKEN);
          window.open(
            ssoURL,
            "SSO Cnfig test",
            "menubar=1,resizable=1,width=600,height=400"
          );
          window.addEventListener(
            "message",
            (e) => {
              console.log("post data ", e.data);
              console.log("post data origin", e.origin);
              if (e.origin !== config.SITE_URL) return;
              if (e.data.success) {
                setSsoTestStepStatus(e.data.ssoTestStepStatus);
                setSsoTestStatus(e.data.ssoTestStatus);
                if (e.data.ssoTestStatus) setMessage(t("messages.sso.msg11"));
              } else {
                setSsoTestStatus(SSO_STATUS_CONSTANTS.SSOTESTSTATUS.FAILED);
                setMessage(e.data.message);
              }
            },
            false
          );
        } else {
          setSsoTestStatus(SSO_STATUS_CONSTANTS.SSOTESTSTATUS.FAILED);
          setMessage(
            t("messages.sso.msg12") + " \n " + t("messages.sso.msg14")
          );
        }
      } else {
        setSsoTestStatus(SSO_STATUS_CONSTANTS.SSOTESTSTATUS.FAILED);
        setMessage(t("messages.sso.msg12") + " \n " + t("messages.sso.msg14"));
      }
    } else {
      setErrorMessage(t("messages.error.err44"));
      alertModalRef.current.toggleDialog();
    }
  }

  /**
   * SSO Deactivation start here
   */
  async function handleDeactivate() {
    setSsoTestStatus(SSO_STATUS_CONSTANTS.SSOTESTSTATUS.PROGRESS);
    ssoDeactivateModalRef.current.close();
    setIsLoading(true);
    let response = await firebaseUtil.saveSSOSettings({
      ...SSOSettings,
      ssoLogin: false,
      ssoProvider: ssoProvider.value,
    });
    setSSOSetting({ ssoLogin: false });
    refreshSSOSettings();
    setDataBaseSSO(false);
    setSSOConfigEnable({ isChecked: false });
    serverResponse.current = response;
    setSnackbarOpen(true);
    setIsLoading(false);
  }

  function onChangeDeactivationSwitch(val) {
    if (navigator.onLine) {
      setSSOSetting({
        ...ssoSetting,
        ssoLogin: true,
      });
      if (!val) {
        ssoDeactivateModalRef.current.toggleDialog();
      }
    } else {
      setErrorMessage(t("messages.error.err44"));
      alertModalRef.current.toggleDialog();
    }
  }
  const onSSOProviderChange = (event) => {
    console.log("event is", event.target.value);
    setAuthSSOProvider(event.target.value)
    if (event.target.value > 0) {
      setSSOSetting({
        ssoLogin: true,
      });
    }
    setSsoProvider(ssoProviders[event.target.value]);
  };

  const getProviderComponent = () => {
    let ssoType = ssoProvider.value;
    if (ssoType === 0) {
      return <></>;
    } else if (ssoType === 1) {
      return (
        <PingFred
          StyledChipInput={StyledChipInput}
          SubHeader={SubHeader}
          SubHeaderWithAsterisk={SubHeaderWithAsterisk}
          CustomAlertText={CustomAlertText}
          FlexRow={FlexRow}
          ButtonContainer={ButtonContainer}
          StyledTextField={StyledTextField}
          MButton={MButton}
          CheckboxHolder={CheckboxHolder}
          Switch={Switch}
          ButtonStyle={SwitchStyle}
          isLoading={isLoading}
          dataBaseSSO={dataBaseSSO}
          ssoTestStatus={ssoTestStatus}
          ssoSetting={ssoSetting}
          SSOSettings={SSOSettings}
          config={config}
          globalAppSettings={globalAppSettings}
          SSO_CONSTANTS={SSO_CONSTANTS}
          sc={sc}
          onChangeDeactivationSwitch={onChangeDeactivationSwitch}
          handleSSOTestConfig={handleSSOTestConfig}
          handleSave={handleSave}
          StyledChip={StyledChip}
        />
      );
    } else {
      return (
        <AzureSSOConfig
          StyledChipInput={StyledChipInput}
          SubHeader={SubHeader}
          SubHeaderWithAsterisk={SubHeaderWithAsterisk}
          CustomAlertText={CustomAlertText}
          FlexRow={FlexRow}
          ButtonContainer={ButtonContainer}
          StyledTextField={StyledTextField}
          MButton={MButton}
          CheckboxHolder={CheckboxHolder}
          Switch={Switch}
          ButtonStyle={SwitchStyle}
          isLoading={isLoading}
          dataBaseSSO={dataBaseSSO}
          ssoTestStatus={ssoTestStatus}
          ssoSetting={ssoSetting}
          SSOSettings={SSOSettings}
          config={config}
          globalAppSettings={globalAppSettings}
          SSO_CONSTANTS={SSO_CONSTANTS}
          sc={sc}
          onChangeDeactivationSwitch={onChangeDeactivationSwitch}
          handleSSOTestConfig={handleSSOTestConfig}
          handleSave={handleSave}
          StyledChip={StyledChip}
        />
      );
    }
  };
  useEffect(() => {
    getProviderComponent();
  }, [ssoProvider.value]);

  /**
   * SSO Deactivation end here
   */
  const SwitchStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "flex-end",
    cursor: isLoading ? "wait" : "pointer",
  };

  return (
    <>
      <StyledContentWrapper
        style={{
          cursor: isLoading ? "wait" : "default",
          opacity: isLoading ? "0.4" : "1",
        }}
      >
        <AlertModal modalRef={alertModalRef} message={errorMessage} />
        <SSOConfigTestModal
          modalRef={ssoConfigTestModalRef}
          message={message}
          ssoTestStatus={ssoTestStatus}
          ssoTestStepStatus={ssoTestStepStatus}
          onHandleSave={handleSave}
        />
        <SSODeactivatetModal
          modalRef={ssoDeactivateModalRef}
          message={message}
          ssoTestStatus={ssoTestStatus}
          onHandleDeactivate={handleDeactivate}
          onHandleCancel={() => {
            setSSOSetting({ ...ssoSetting, ssoLogin: true });
            ssoDeactivateModalRef.current.close();
          }}
        />

        <PageTitle style={{ marginBottom: 0 }}>
          {t("ssoServerIntegration")}
        </PageTitle>
        <FlexRow
          style={{
            marginLeft: "15px",
          }}
        >
          <SubHeader>{t('ssoProvider')}:</SubHeader>
        </FlexRow>
        <FlexRow
          style={{
            marginLeft: "15px",
            marginTop: "20px",
          }}
        >
          <DropdownCustom
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            selectVal={ssoProvider}
            selectOpts={ssoProviders}
            onChange={onSSOProviderChange}
            isDisabled={dataBaseSSO}
          ></DropdownCustom>
        </FlexRow>
        <FlexRow
          style={{
            marginLeft: "15px",
            marginTop: "20px",
            fontSize: "14px",
            color: "#545963",
          }}
        >
          {t("ssoConfigHelperText")}
        </FlexRow>

        <div style={{ marginLeft: "15px", marginTop: "20px" }}>
          {getProviderComponent()}
        </div>
        <BottomNavLinks />
      </StyledContentWrapper>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
      >
        <SnackbarContent error={serverResponse.current.status ? false : true}>
          {serverResponse.current.msg}
        </SnackbarContent>
      </Snackbar>
    </>
  );
}
